<ng-container *ngIf="selectedCategories.length">
    <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_MODULES' | translate }}</h3>
    <mat-chip-set class="chip-list wrap mb-16">
        <mat-chip class="chip maxbrain-500" (removed)="removeFromList(category)" *ngFor="let category of selectedCategories">
            {{ category.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </mat-chip-set>
</ng-container>

<div fxLayout="row" fxLayoutAlign="space-between center" class="bg-zinc-50 p-16 mb-24" *ngIf="audienceRelevantExperiences.length > 1">
    <div fxLayout="row" fxLayoutAlign="start baseline" class="text-truncate pr-12">
        <span class="text-gray-500">{{ 'ENGAGE.AUDIENCE.LABELS.FILTERED_BY_EXPERIENCE' | translate }}:</span>
        <span>&nbsp;</span>
        <span class="text-black text-truncate" *ngFor="let relevantExperience of audienceRelevantExperiences; let last = last">
            {{ relevantExperience.experience.name }}<span *ngIf="!last">,&nbsp;</span>
        </span>
    </div>

    <div fxLayout="row" fxLayoutAlign="flex-end center" class="pointer" (click)="navigateToChangeExperience()">
        <span class="text-primary-500 mr-4">{{ 'PAGE.ENGAGE.TAB.EXPERIENCE.BUTTONS.CHANGE_EXPERIENCE' | translate }}</span>
        <mat-icon class="text-primary-500">keyboard_arrow_right</mat-icon>
    </div>
</div>

<div class="overflow-y-auto max-h-[342px]">
    <ng-container *ngIf="!isLoading; else shimmer">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="border border-gray-300 mt-24">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node
                fxLayout="column"
                fxLayoutAlign="start"
                class="mat-elevation-z pointer mat-panel-title"
                *matTreeNodeDef="let node"
                matTreeNodePadding
                [matTreeNodeToggle]="isNodeExpandable(node)"
                [class.disabled]="!isNodeExpandable(node)"
                (click)="expandNode(node, $event)"
            >
                <div class="py-16" fxLayout="row" fxLayoutAlign="flex-start center">
                    <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name" *ngIf="node.numberOfResults; else noOfferings">
                        <mat-icon class="mat-icon-rtl-mirror mr-8" fxLayoutAlign="flex-start center">
                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>
                    <ng-template #noOfferings>
                        <mat-icon fxLayout="row" fxLayoutAlign="flex-start center" class="mat-icon-rtl-mirror lens-icon min-h-10 ml-16"> lens </mat-icon>
                    </ng-template>

                    <div class="w-100-p pr-16 card-content" fxLayout="row">
                        <div class="card-name">
                            <span>{{ node.name }} </span>
                        </div>

                        <ng-container *ngIf="!node.isParentSelected; else alreadySelected">
                            <app-flat-button
                                class="!pointer-events-auto z-10"
                                [label]="'GENERAL.BUTTON.SELECT'"
                                (onClick)="onSelectPostingStream(node); $event.stopPropagation()"
                                *ngIf="!node.isSelected; else unselect"
                            ></app-flat-button>
                        </ng-container>

                        <ng-template #unselect>
                            <app-white-button
                                class="!pointer-events-auto z-10"
                                [label]="'GENERAL.BUTTON.UNSELECT'"
                                (onClick)="onDeselectPostingStream(node); $event.stopPropagation()"
                            ></app-white-button>
                        </ng-template>

                        <ng-template #alreadySelected>
                            <span class="text-gray-400 text-sm min-w-56 text-end">{{ 'GENERAL.LABEL.ALREADY_SELECTED' | translate }}</span>
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="treeControl.isExpanded(node)">
                    <app-select-course-offering-posting
                        class="w-full"
                        [offerringGroupOfferings]="node.offerringGroupOfferings"
                        (onSelectCourse)="onSelectPostingStream($event)"
                        (onDeselectCourse)="onDeselectPostingStream($event)"
                        [isSelectable]="false"
                    ></app-select-course-offering-posting>
                </div>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node
                fxLayout="column"
                fxLayoutAlign="start"
                class="mat-elevation-z pointer mat-panel-title"
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
                [matTreeNodeToggle]="isNodeExpandable(node)"
                [class.disabled]="!isNodeExpandable(node)"
                (click)="expandNode(node, $event)"
            >
                <div class="py-16" fxLayout="row" fxLayoutAlign="flex-start center">
                    <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>

                    <div class="w-100-p pr-16 card-content" fxLayout="row">
                        <div class="card-name">
                            <span>{{ node.name }} </span>
                        </div>

                        <ng-container *ngIf="!node.isParentSelected; else alreadySelected">
                            <app-flat-button
                                class="!pointer-events-auto z-10"
                                [label]="'GENERAL.BUTTON.SELECT'"
                                (onClick)="onSelectPostingStream(node); $event.stopPropagation()"
                                *ngIf="!node.isSelected; else unselect"
                            ></app-flat-button>
                        </ng-container>

                        <ng-template #unselect>
                            <app-white-button
                                class="!pointer-events-auto z-10"
                                [label]="'GENERAL.BUTTON.UNSELECT'"
                                (onClick)="onDeselectPostingStream(node); $event.stopPropagation()"
                            ></app-white-button>
                        </ng-template>

                        <ng-template #alreadySelected>
                            <span class="text-gray-400 text-sm min-w-56 text-end">{{ 'GENERAL.LABEL.ALREADY_SELECTED' | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </mat-tree-node>
        </mat-tree>
    </ng-container>

    <ng-template #shimmer>
        <div class="shimmer-container min-w-full">
            <div class="shimmer pt-24">
                <div class="shimmer-card table animate"></div>
            </div>
        </div>
    </ng-template>
</div>

<div class="p-0 pt-24 w-full" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button class="mr-8" [label]="'GENERAL.LABEL.CLEAR_SELECTION'" (onClick)="onClearSelection()"></app-white-button>
    <div fxLayout="row" fxLayoutAlign="end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="closeDialog.emit(false)"></app-white-button>
        <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()" [isLoading]="isLoading" [disabled]="!hasSelectionChanges"></app-flat-button>
    </div>
</div>
